module.exports = class BaseRequest {
    constructor (apiDomain)
    {
        this.apiDomain = apiDomain
        this.swrOptions = { shouldRetryOnError: false , revalidateOnFocus: false, revalidateOnReconnect: false }
    }
}